export default __webpack_public_path__ + "static/media/xmark-solid.6837248f.svg";